import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const conversationImporterSelectors = importerSelectors(
  'conversation.importer',
)

export default conversationImporterSelectors
